import React from 'react';
import PropTypes from 'prop-types';
import SecondaryNav from './secondary_nav';

import instagram_logo from './images/instagram-icon.png';
import fb_logo from './images/facebook-icon2.png';
import tw_logo from './images/twitter-icon.png';
import yt_logo from './images/youtube-icon.png';

import './style.scss';

const Footer = ({ footer }) => {
    return (
        <footer className="container-fluid">
            <div className="inner-container">
                <div className="row">
                    <div className="col-xs-12">
                        <div className="social-links">
                            <a
                                className="fb"
                                href="https://www.facebook.com/illinoislottery/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img src={fb_logo} alt="Illinois Lottery on Facebook" />
                            </a>
                            <a
                                className="gr"
                                href="https://www.instagram.com/illinoislottery/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img src={instagram_logo} alt="Illinois Lottery on Instagram" />
                            </a>
                            <a
                                className="tw"
                                href="https://twitter.com/illinoislottery/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img src={tw_logo} alt="Illinois Lottery on Twitter" />
                            </a>
                            <a
                                className="yt"
                                href="https://www.youtube.com/user/TheIllinoisLottery"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img src={yt_logo} alt="Illinois Lottery on Youtube" />
                            </a>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <SecondaryNav footer={footer} />
                    </div>
                </div>

                <div className="row">
                    <div className="disclaimer col-sm-12">
                        <p>
                            Play Responsibly. You must be 18 years of age or older to enter the Promotion.
                            Gambling problem? Crisis counseling and referral
                            services can be accessed at 1-800-GAMBLER.
                            <br />
                            For more info or to exclude yourself call
                            1-800-252-1775 or visit Illinoislottery.com.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

Footer.propTypes = {
    footer: PropTypes.array.isRequired,
};

export default Footer;
